import React from 'react';
import './About.css';

export default function About() {
    return (
        <div className="about-content">

            {/* Hero banner */}
            <div className="about-hero">
                <div className="about-hero-inner">
                    <p className="about-hero-eyebrow">Who We Are</p>
                    <h1 className="about-hero-title">About Us</h1>
                    <p className="about-hero-sub">
                        Built on over 20 years of hands-on experience in farming and agricultural machinery.
                    </p>
                </div>
            </div>

            <div className="about-body">

                {/* Story */}
                <section className="about-card">
                    <div className="about-card-accent" />
                    <div className="about-card-body">
                        <h2 className="about-section-title">Our Story</h2>
                        <p>
                            What started as a farming background naturally grew into machinery dealing, with over two decades
                            of experience buying, selling, and working with agricultural equipment. Over the years, we've
                            built a strong network across the UK and Ireland, supplying a wide range of machinery to farmers,
                            contractors, and dealers.
                        </p>
                        <p>
                            We understand that older parts can be difficult to source, lead times from dealers can be long,
                            and in many cases, the cost of new simply doesn't make sense. That's why we focus on providing
                            reliable used parts that keep your machinery working without unnecessary delays or expense.
                        </p>
                    </div>
                </section>

                {/* What we do */}
                <section className="about-card">
                    <div className="about-card-accent" />
                    <div className="about-card-body">
                        <h2 className="about-section-title">What We Do</h2>
                        <p>
                            We specialise in breaking Kverneland ploughs, carefully stripping them down to recover
                            high-quality used parts. Every part is checked to make sure it’s fit for purpose and ready to go back to work in the field.
                        </p>
                        <p>Because we deal directly and keep things simple, we're able to offer:</p>

                        <ul className="about-benefits">
                            <li>
                                <span className="about-benefit-icon"><i className="fas fa-check" /></span>
                                <span>Quality used parts you can trust</span>
                            </li>
                            <li>
                                <span className="about-benefit-icon"><i className="fas fa-check" /></span>
                                <span>Fair, competitive pricing</span>
                            </li>
                            <li>
                                <span className="about-benefit-icon"><i className="fas fa-check" /></span>
                                <span>Fast, straightforward service</span>
                            </li>
                            <li>
                                <span className="about-benefit-icon"><i className="fas fa-check" /></span>
                                <span>Knowledge backed by real farming experience</span>
                            </li>
                        </ul>
                    </div>
                </section>

                {/* Owner */}
                <section className="about-owner">
                    <div className="about-owner-photo-wrap">
                        <img
                            src="/images/AboutusCoverphoto.png"
                            alt="Ernest Charlton"
                            className="about-owner-photo"
                        />
                    </div>
                    <div className="about-owner-text">
                        <p className="about-owner-name">Ernest Charlton</p>
                        <p className="about-owner-title">Owner, Plough Breakers</p>
                    </div>
                </section>

                {/* Closing statement */}
                <section className="about-closing">
                    <p>
                        Whether you're replacing a single worn part or rebuilding a full plough, we understand what
                        matters — reliability, value, and getting the job done without delay.
                    </p>
                    <p className="about-closing-emphasis">
                        At its core, this is a family-run operation built on practical knowledge, long-standing
                        relationships, and a genuine understanding of the industry.
                    </p>
                </section>

                {/* CTA */}
                <div className="about-cta">
                    <a href="/contact" className="about-cta-btn">
                        <i className="fas fa-envelope" /> Get in Touch
                    </a>
                    <a href="/search" className="about-cta-btn about-cta-btn-outline">
                        <i className="fas fa-search" /> Browse Parts
                    </a>
                </div>

            </div>
        </div>
    );
}